module.exports = __webpack_public_path__ + "img/Picture29.60f5f6cf.png";